const input = {
  baseStyle: {
    _focusVisible: {
      borderColor: 'primary.500',
    },

    field: {
      _focusVisible: {
        borderColor: 'primary.500',
      },
      color: 'black.50',
      fontWeight: '400',

      _placeholder: {
        color: 'black.200',
      },
    },
  },
};

export default input;
